export enum ERequestType {
  Restaurant = "Restaurant",

  Customer = "Customer",

  Courier = "Courier",

  Admin = "Admin",

  TableSelfService = "TableSelfService",

  Reseller = "Reseller",
}
